import {useEffect, useState} from "react";
import {
    CATEGORY_GROUPS, CATEGORY_KEYS, CategoryGroup, STOCK_SECTORS, STOCK_SECTOR_KEYS,
    StockSector, categoryGroup, categoryLabel, parseStockCategory, stockCategory,
} from "../global/categories";
import "../assets/css/component/CategoryPicker.css";

type Props = {value: string; onChange: (category: string) => void};

export default function CategoryPicker({value, onChange}: Props) {
    const [group, setGroup] = useState<CategoryGroup | "">(categoryGroup(value) || "");
    const [sector, setSector] = useState<StockSector | "">(parseStockCategory(value)?.sector || "");
    const selectedStock = parseStockCategory(value);

    // Hydrate the editor when an existing post arrives; empty values also represent an unfinished choice.
    useEffect(() => {
        if (value) {
            setGroup(categoryGroup(value) || "");
            setSector(parseStockCategory(value)?.sector || "");
        }
    }, [value]);

    return <fieldset className="CategoryPicker">
        <legend>카테고리</legend>
        <div className="category-picker-fields">
            <label>대주제
                <select value={group} onChange={event => {
                    setGroup(event.target.value as CategoryGroup | "");
                    setSector("");
                    onChange("");
                }}>
                    <option value="">대주제 선택</option>
                    {CATEGORY_KEYS.map(key => <option key={key} value={key}>{key}</option>)}
                </select>
            </label>
            {group && group !== "주식" && <label>소주제
                <select value={value} onChange={event => onChange(event.target.value)}>
                    <option value="">소주제 선택</option>
                    {CATEGORY_GROUPS[group].map(category => <option key={category} value={category}>{category}</option>)}
                </select>
            </label>}
            {group === "주식" && <>
                <label>섹터
                    <select value={sector} onChange={event => {
                        setSector(event.target.value as StockSector | "");
                        onChange("");
                    }}>
                        <option value="">섹터 선택</option>
                        {STOCK_SECTOR_KEYS.map(key => <option key={key} value={key}>{key}</option>)}
                    </select>
                </label>
                {sector && <label>세부 업종
                    <select value={selectedStock ? value : ""} onChange={event => onChange(event.target.value)}>
                        <option value="">세부 업종 선택</option>
                        <option value={stockCategory(sector)}>섹터 전체</option>
                        {STOCK_SECTORS[sector].map(industry => (
                            <option key={industry} value={stockCategory(sector, industry)}>{industry}</option>
                        ))}
                    </select>
                </label>}
            </>}
        </div>
        {value && <p className="category-title-preview">제목 표시: <strong>[{categoryLabel(value)}]</strong> 입력한 제목</p>}
    </fieldset>;
}
